var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAssetsLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_assets_loader",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.292,
    height: 39.083,
    viewBox: "0 0 84.292 39.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 84.292,
    height: 39.083
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M594.53,14.776V5.126a.581.581,0,1,0-1.161,0v9.65h-3.984V5.232a.573.573,0,0,0-.123-.352.576.576,0,0,0-.508-.3H569.961V0H555.978l-1.2,10.846a8.484,8.484,0,0,1-.735,8.045h3.713v13.8h8.624V29.777A10.9,10.9,0,0,1,577.266,18.89H588.21V31.9a.58.58,0,0,0,1.161,0v-1.54h4V31.9a.581.581,0,0,0,1.162,0V17.271h.56v-2.5Zm-35.216-1.568a1.286,1.286,0,0,0-.683-1l.371-.964a.489.489,0,1,0-.436-.664.494.494,0,0,0,.1.51l-.384,1a1.25,1.25,0,0,0-.245-.023,1.28,1.28,0,0,0-1.271,1.146h-.595l1.28-11.563h5.4V13.208Zm7.357,0h-2.759V1.645h2.759Zm11.835,1.568H569.96V10.9h8.546Zm0-5.041H569.96v-4h8.546Zm9.718,5.041h-8.556V10.9h8.556Zm0-5.041h-8.556v-4h8.556ZM593.369,29.2h-4V27.106h4Zm0-3.254h-4V23.853h4Zm0-3.253h-4V20.6h4Zm0-3.253h-4V17.271h4Z",
    transform: "translate(-510.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M13.618,296.754a1.308,1.308,0,0,0-.334-1.267l-2.758-1.568,0,0a.259.259,0,0,0-.118-.03.268.268,0,0,0-.186.461l1.408,1.738L1.4,306.353a.82.82,0,0,0-1.16,1.16,8.646,8.646,0,0,0,12.211,0,8.633,8.633,0,0,0,1.166-10.759Z",
    transform: "translate(0 -270.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M207.963,77.077a10.924,10.924,0,0,1,5.822-1.7h4.755a6.837,6.837,0,0,0,.214-9.163l-3.476-1.953-.484.848-2.15-1.228-1.817-1.037a1.574,1.574,0,0,0-.038-.206,1.731,1.731,0,0,0-3.421.269l-.166,2.126-.237,3.052c0,.044,0,.087,0,.13h-2.414a5.8,5.8,0,0,0-4.111,1.706l-8.028,10.747a14,14,0,0,1,1.609,6.271c0,.275-.014.548-.035.82l9.928-6.069a10.974,10.974,0,0,1,4.054-4.616m9.541-5.922a.678.678,0,0,1,.678.7.686.686,0,0,1-.66.657.678.678,0,1,1-.018-1.357m-3.294-5.021-.485.848,2.2,1.235h-4.681c0-.043,0-.086,0-.13l-.3-3.837ZM208.5,62.725a.608.608,0,0,1,1.2.123.626.626,0,0,1-.082.3.606.606,0,0,1-.526.309h-.013a.608.608,0,0,1-.583-.729M202.3,71.96c-.171.188-.364.4-.594.643-1.651,1.731-6.991,9.1-7.044,9.172A.663.663,0,1,1,193.591,81c.222-.306,5.446-7.514,7.159-9.31.218-.228.405-.435.57-.618,1.314-1.451,1.765-1.684,5.069-1.684h9.532a.663.663,0,0,1,0,1.327h-9.532c-2.956,0-3.063.118-4.086,1.248",
    transform: "translate(-177.39 -56.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M357.133,263.113a9.241,9.241,0,1,0,9.241,9.24,9.241,9.241,0,0,0-9.241-9.24m0,13.678a4.436,4.436,0,1,1,4.436-4.437,4.436,4.436,0,0,1-4.436,4.437",
    transform: "translate(-320.74 -242.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M742.453,263.113a9.241,9.241,0,1,0,9.24,9.24,9.241,9.241,0,0,0-9.24-9.24m0,13.678a4.436,4.436,0,1,1,4.435-4.437,4.437,4.437,0,0,1-4.435,4.437",
    transform: "translate(-675.986 -242.577)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssetsLoader);
export default __webpack_public_path__ + "static/media/icon_assets_loader.0bc740c3b08b2b5085c231f1be5164e0.svg";
export { ForwardRef as ReactComponent };